export const HOME_ROUTE = "/";
export const OFFER_30_ROUTE = "/paywall/offer/30/1month15-1year70";
export const OFFER_50_ROUTE = "/paywall/offer/50/3months30";
export const FINISH_EMAIL_ROUTE = "/finish_email";
export const SLEEPS_PROBLEMS_ROUTE = "/lp/sleep-problems";
